import { types, successAction } from "@authzsvc/api-lib";

const initialState = [];

const identityAccountsReducer = (state = initialState, action) => {
  switch (action.type) {
    case successAction(types.GET_CURRENT_IDENTITY_ACCOUNTS):
      return action.payload.data;
    default:
      return state;
  }
};

export default identityAccountsReducer;
